"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weekdays = exports.months = void 0;
var months = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_').map(function (v) {
  return v.substr(0, 3);
});
exports.months = months;
var weekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_').map(function (v) {
  return v.substr(0, 2);
});
exports.weekdays = weekdays;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@z-r/calendar/lib/locale/en_us.js
// module id = 1819
// module chunks = 6 7 17 18